export default "__VITE_ASSET__59095ed8__"